import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class DemoComponent extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.notifications !== this.props.notifications) {
      this.showNotifications(this.props.notifications);
    }
  }

  showNotifications = (notifications) => {
    notifications.forEach((notification) => {
      const { message, level = 'default' } = notification;
      if (level === 'success') toast.success(message);
      else if (level === 'error') toast.error(message);
      else if (level === 'warning') toast.warning(message);
      else toast(message);
    });
  };

  closeAll = () => {
    toast.dismiss();
  };

  render() {
    const { notifications } = this.props;
    return (
      <div>
        {notifications && notifications.length > 2 && (
          <button className="clearAllNotifcations" onClick={this.closeAll}>
            Clear All Notifications
          </button>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  notifications: state.notificationSystem,
}))(DemoComponent);
